module.exports = __webpack_public_path__ + "img/question11.9416167c.png";